export default "__VITE_ASSET__Do0hQ4gJ__"